import { Box, Grid, Modal, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { modalStyle } from "./styles/commonStyles";
import GenericButton from "../ui/GenericButton";
import { colorPalette } from "@command-center-app/utils/colorPalette";
import { GenericModalProps } from "@command-center-app/index";

const GenericModal = ({
  open = false,
  handleClose,
  children,
  modalTitle = "",
  showFooter = true,
  showCancel = true,
  footerButtons = <></>,
  width = 500,
}: GenericModalProps) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...modalStyle, width, border: "none", borderRadius: "4px" }}>
        {modalTitle !== "" && (
          <>
            <Grid
              container
              sx={{
                justifyContent: "space-between",
                borderBottom: `1px solid ${colorPalette.colorVeryLightGray}`,
                p: 2,
                alignItems: "center",
              }}
            >
              <Typography sx={modalStyle.headerStyle}>
                {modalTitle}{" "}
              </Typography>
              <Button
                variant="text"
                disableRipple
                onClick={handleClose}
                sx={{
                  p: 0,
                  width: "fit-content",
                  justifyContent: "end",
                  color: colorPalette.colorPureBlack,
                  fontSize: "18px",
                  "&:hover": {
                    background: "transparent",
                  },
                }}
              >
                &times;
              </Button>
            </Grid>
          </>
        )}
        {children}

        {showFooter === true && (
          <>
            <Grid
              container
              sx={{ justifyContent: "end", alignItems: "center", p: 2, gap: 1 }}
            >
              {showCancel && (
                <GenericButton
                  text="Cancel"
                  variant="outlined"
                  onClick={handleClose}
                  textColor={colorPalette.colorAccent}  
                  backgroundColor="none"
                  style={{ borderColor: colorPalette.colorAccent }}
                />
              )}
              {footerButtons}
            </Grid>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default GenericModal;
